import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#home'
  }, {
    name: 'Soluciones',
    href: '#nicho'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Metodología',
    href: '#metodologia'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-petrol/90 backdrop-blur-md py-4 shadow-lg shadow-black/20 border-b border-turquoise/10' : 'bg-transparent py-6'}`} data-id="element-167">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-168">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2 group" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/qNXWZ3SnSyEmwvnJR5unkd/1000116463.png" alt="Anchor Innovative Solutions" className="h-10 w-auto mix-blend-screen transition-transform group-hover:scale-105" data-id="element-170" />
          <span className="font-serif text-xl font-bold tracking-wider text-white" data-id="element-171">
            ANCHOR
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-172">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-silver hover:text-turquoise transition-colors" data-id="element-173">
              {link.name}
            </a>)}
          <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="bg-turquoise hover:bg-turquoise-hover text-petrol font-semibold text-sm px-6 py-2.5 rounded transition-all hover:shadow-[0_0_15px_rgba(0,212,170,0.3)]" data-id="element-174">
            Auditoría Gratis
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-silver hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-175">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-176" /> : <MenuIcon className="w-6 h-6" data-id="element-177" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-petrol-light border-t border-petrol-lighter shadow-xl" data-id="element-178">
          <div className="flex flex-col px-6 py-4 gap-4" data-id="element-179">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-base font-medium text-silver hover:text-turquoise py-2" data-id="element-180">
                {link.name}
              </a>)}
            <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="bg-turquoise text-petrol font-semibold text-center px-6 py-3 rounded mt-2" data-id="element-181">
              Auditoría Gratis
            </a>
          </div>
        </div>}
    </header>;
}